"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var storage_1 = __importDefault(require("../storage"));
var moduleName = "oidc-auth";
exports.default = moduleName;
angular_1.default.module(moduleName, [storage_1.default]);
